import { createContext, useContext, useState, useEffect } from "react"
import { auth } from "../firebase"
import { onAuthStateChanged, signOut } from "firebase/auth"

const StateContext = createContext()

// Brand primary for inline styles (brand-600: AA contrast with white text)
const BRAND_COLOR = '#8B579C'

export const ContextProvider = ({ children }) => {
    const [screenSize, setScreenSize] = useState(undefined)
    const [activeMenu, setActiveMenu] = useState(true)
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [authLoading, setAuthLoading] = useState(true)
    const [adminUser, setAdminUser] = useState(null)

    // Check authentication status on mount
    useEffect(() => {
        const token = localStorage.getItem('token')
        setIsAuthenticated(!!token)
        setAuthLoading(false)
    }, [])

    // Google profile of the signed-in admin, for the header
    useEffect(() => onAuthStateChanged(auth, (user) => {
        setAdminUser(user ? { name: user.displayName, email: user.email, photo: user.photoURL } : null)
    }), [])

    // Authentication functions
    const login = (token) => {
        localStorage.setItem('token', token)
        setIsAuthenticated(true)
    }

    const logout = async () => {
        localStorage.removeItem('token')
        setIsAuthenticated(false)
        try { await signOut(auth) } catch (e) { /* ignore */ }
        window.location.href = '/login'
    }

    return (
        <StateContext.Provider value={{
            screenSize, setScreenSize,
            currentColor: BRAND_COLOR,
            activeMenu, setActiveMenu,
            isAuthenticated, authLoading, login, logout,
            adminUser
        }}>
            {children}
        </StateContext.Provider>
    )
}

export const useStateContext = () => useContext(StateContext)
